import React from 'react'

export interface FilterBadgeProps {
  activeFilterCount: number
  onClearAll: () => void
}

export const FilterBadge: React.FC<FilterBadgeProps> = ({
  activeFilterCount,
  onClearAll,
}) => {
  if (activeFilterCount === 0) return null

  return (
    <span className="filter-badge" data-testid="filter-badge">
      <i className="fa fa-filter" />
      <span className="filter-badge-count">{activeFilterCount}</span>
      <button
        className="filter-badge-clear btn btn-sm"
        onClick={onClearAll}
        aria-label="Clear all filters"
      >
        <i className="fa fa-times" />
      </button>
    </span>
  )
}
